import { FIVE_MINUTES_IN_MILLISECONDS } from '@/constants';
import queryKeys from '@/constants/queryKeys';
import { getNotifications } from '@/services/api/requests/notifications';
import { useQuery } from '@tanstack/react-query';

const LATEST_NOTIFICATIONS_DISPLAY_COUNT = 5;

const useGetLatestNotifications = ({ enabled } = { enabled: true }) => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.notifications.latest],
    enabled,
    staleTime: FIVE_MINUTES_IN_MILLISECONDS,
    queryFn: async () => {
      const response = await getNotifications(1, LATEST_NOTIFICATIONS_DISPLAY_COUNT);

      return response.data;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useGetLatestNotifications;
